export const environment = {
	production: false,
	staging: true,
	baseApiUrl: 'https://stg.top.br.atos.net/rest/',
	logoSource: 'assets/images/logo/msp-blue/',
	supportcenter: 'supportcenter_stg',
	defaultMspCssPaternId: '20',
};
